import { SectionContainer } from "@silversea-ssc/ui-components-react"
import React from "react"
import styles from "./Footer.module.scss"
import SubFooter from "./SubFooter/SubFooter"

const Footer: React.FC<React.PropsWithChildren<unknown>> = () => {
    const urls = [
        {
            href: "https://www.silversea.com/imprint.html",
            title: "Imprint",
        },
        {
            href: "https://www.silversea.com/terms-and-conditions.html",
            title: "Terms and Conditions",
        },
        {
            href: "https://www.silversea.com/digital-terms-of-use-and-end-user-license-agreement.html",
            title: "Terms of Use",
        },
        {
            href: "https://www.silversea.com/privacy-policy.html",
            title: "Privacy Policy",
        },
    ]

    return (
        <footer className={styles.footer} id="footer" data-content-name="footer">
            <SectionContainer backgroundColor="transparent">
                <div className={styles.subFooter}>
                    <SubFooter links={urls} />
                </div>
            </SectionContainer>
        </footer>
    )
}
export default Footer
